<template lang="pug">
  .slovakia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/slovakia-min.png"
      )
      span {{ gettext('Словакия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Слова́кия - маленькая страна в Европе, которая разделена на части горами - массивными Карпатами. Она является одной из славянских стран, молодых членов Евросоюза. Это индустриальная страна с динамично развивающейся экономикой. Благодаря стабильному потоку иностранных инвестиций после вхождения в Еврозону, Словакия нацелила свою экономику на рынок экспорта, в основном в сфере машиностроения, электротехнической индустрии. Так, как банковская сфера в основном приватизирована иностранными лицами, многие европейцы не боятся инвестировать свои вклады в многие отрасли экономики Словакии, что делает ее весьма конкурентоспособной не только среди стран бывшего СССР, но и в мире.') }}
        p {{ gettext('Также уверенных темпов в развитии набирает сельское хозяйство, все больше внедряя современные технологии в производство.') }}
        p {{ gettext('Стоит заметить, что Словакия является центром для горно-лыжного туризма, с большим разнообразием природных красот, оздоровительных туристических комплексов которые вносят свой весомый вклад в бюджет страны.') }}
        p {{ gettext('Население страны многонациональное, в основном за счет мигрантов из соседних стран - венгров, чехов, поляков, украинцев и составляет в общем количестве около 5,4 миллиона человек. Сами же словаки уезжают в более богатые страны - Австрию, Германию, Великобританию для поиска хорошего заработка, оставляя незаполненными рабочие места в своей стране.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/work`")
            span {{ gettext('Work') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/taxation`")
            span {{ gettext('Taxation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-hours`")
            span {{ gettext('Working hours') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/slovakia-min.png'})
  },
  name: 'Slovakia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Slovakia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/slovakia/index.vue